export default {
  title: '会員デコレーション',
  previewTitle: '会員センター',
  pageSetting: 'ページ設定',
  pageTitle: 'ページタイトル',
  pageTitlePlaceholder: 'ページタイトルを入力してください',
  defaultPageTitle: 'マイページ',
  modules: '機能モジュール',
  template: 'ページテンプレート',
  templateType: 'テンプレートタイプ',
  bgColor: '背景色',
  moduleList: 'モジュールリスト',
  moduleConfig: 'モジュール設定',
  editText: 'テキスト編集',
  editTextTitle: 'テキスト編集',
  templateGoldBlack: 'ブラックゴールドテンプレート',
  templateGoldWhite: 'プラチナテンプレート',
  useDefaultIcon: 'デフォルトアイコンを使用',
  addNav: 'ナビゲーション追加',
  navNamePlaceholder: 'ナビゲーション名を入力してください',
  navLinkPlaceholder: 'リンク先を入力してください',
  memberCenterLink: '会員センターアドレス',
  copyLinkTitle: 'リンクをコピー',
  copyAddress: 'アドレスをコピー',
  copy: 'コピー',
  copySuccess: 'コピーしました',
  scanToPreview: 'スキャンしてプレビュー',
  linkTipH5: 'このリンクはH5環境用です',
  syncConfig: '設定を同期',
  syncConfigTitle: '設定の同期',
  syncConfigDesc: '現在の言語（{lang}）の設定を以下に同期：',
  syncConfigSuccess: '同期が完了しました',
  moduleNames: {
    MemberInfo: '会員情報',
    NavBar: 'ナビゲーションバー',
    PointsRedPacket: 'ポイント＆レッドパケット',
    TabBar: 'タブバー',
  },
  labelName: {
    levelName: 'ダイヤモンド会員',
    progressLabel: 'アップグレードまで',
    progressUnit: '成長値',
    benefitsText: '会員特典',
    pointsTitle: 'マイポイント',
    pointsRule: '交換ルール',
    pointsExchange: 'ポイント交換',
    redpacketTitle: 'マイレッドパケット',
    redpacketRule: '交換ルール',
    redpacketExchange: 'レッドパケット交換',
  },
  formLabel: {
    memberLevel: '会員レベル',
    memberBenefits: '会員特典',
    pointsModule: 'ポイントモジュール',
    points: 'ポイント',
    rule: 'ルール',
    pointsExchange: 'ポイント交換',
    redpacketModule: 'レッドパケットモジュール',
    redpacket: 'レッドパケット',
    redpacketExchange: 'レッドパケット交換',
  },
};